import { Component, Input, OnInit } from '@angular/core';
import { IApiInvestigation, IApiInvestigationStaff, IApiUser } from 'src/app/shared/modules/graphql/types/types';
import { DialogCloseResult, DialogContentBase, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/shared/services';
import { tap } from 'rxjs/operators';
import { investigationScheduledDateViewAll, investigationScheduledDateUpdateAll, investigationScheduledDateUpdateOwn } from 'src/app/shared/helpers/auth-config/investigations.config';
import { DistanceSelectionPayload } from '../../calendar/calendar-filters/calendar-user-distance-filter/calendar-user-distance-filter.component';
import { InvestigationEditInsuredContactedComponent } from 'src/app/components/shared/investigations/investigation-edit-insured-contacted/investigation-edit-insured-contacted.component';
import { InvestigationEditScheduleDateComponent } from 'src/app/components/shared/investigations/investigation-edit-schedule-date/investigation-edit-schedule-date.component';

@Component({
  selector: 'app-investigation-user-calendar-profile-sidebar',
  templateUrl: './investigation-user-calendar-profile-sidebar.component.html',
  styleUrls: ['./investigation-user-calendar-profile-sidebar.component.scss']
})
export class InvestigationUserCalendarProfileSidebarComponent extends DialogContentBase implements OnInit {
  public authConfig = {
    investigationScheduledDateViewAll,
    investigationScheduledDateUpdateAll,
    investigationScheduledDateUpdateOwn
  }

  @Input() public investigatorResults: IApiUser[] = [];
  @Input() public investigation: IApiInvestigation = null;
  @Input() public selectedInvestigator: IApiUser = null;
  @Input() public from: string = 'DASHBOARD_ASSIGNED';
  @Input() public distanceSelection: DistanceSelectionPayload = {
    userIds: [],
    metrics: [],
  };

  public currentUser = null;
  public investigator: IApiUser = null;
  public staffList: IApiUser[] = [];
  public userIds: string[] = [];

  constructor(
    private auth: AuthService,
    public dialog: DialogRef,
    private dialogService: DialogService,
  ) {
    super(dialog);
  }

  close(result = false) {
    this.dialog.close(result)
  }

  ngOnInit() {
    this.getAuthenticated().subscribe(() => {
      this.investigator = this.selectedInvestigator;
      this.staffList = (this.investigatorResults || []).map(u => ({
        ...u,
        userName: `${u.firstName} ${u.lastName}`
      }));
      this.userIds = this.investigatorResults.map(u => u.id);
    });
  }

  private getAuthenticated(): Observable<IApiUser> {
    return this.auth.authenticatedUser.pipe(
      tap((user) => this.currentUser = user)
    );
  }

  public changeInvestigator(event: IApiUser) {
    this.investigator = event;
  }

  public nextSchedule() {
    if (this.investigation?.InsuredContacted?.id) {
      this.editDetails();
    } else {
      this.addInsuredContacted();
    }
  }

  public addInsuredContacted() {
    const dialog: DialogRef = this.dialogService.open({
      content: InvestigationEditInsuredContactedComponent,
      width: 600,
      maxWidth: 600,
      preventAction: (ev) => {
        return ev !== 'closed' as any;
      },
    });
    const userInfo = dialog.content.instance as InvestigationEditInsuredContactedComponent;
    userInfo.investigationStaff = this.investigation.InvestigationStaff as IApiInvestigationStaff[];
    userInfo.investigation = this.investigation;
    userInfo.headerIcon = 'assets/svg/warning.svg';

    dialog.result.subscribe((result: any) => {
      if (result?.id as any) {
        this.investigation.InsuredContacted = result;
        this.editDetails();
      }
    })
  }

  public editDetails() {
    const dialog: DialogRef = this.dialogService.open({
      content: InvestigationEditScheduleDateComponent,
      width: 800,
      maxWidth: 800,
      preventAction: (ev) => {
        return ev !== 'closed' as any;
      },
    });

    const userInfo = dialog.content.instance as InvestigationEditScheduleDateComponent;
    userInfo.investigationStaff = this.investigation.InvestigationStaff as IApiInvestigationStaff[];

    userInfo.investigation = this.investigation;
    userInfo.headerIcon = 'assets/svg/warning.svg';
    userInfo.mode = "EDIT_PENDING_SCHEDULE_CALENDAR";

    dialog.result.subscribe((result: DialogCloseResult) => {
      if (result === true) {
        this.userIds = [...this.userIds];
      }
    })
  }

}
